import { useCallback } from 'react';
import { useInRouterContext, useNavigate } from 'react-router-dom';

/**
 * Navigation utilisable avec ou sans routeur parent.
 * Hors routeur (rendu isolé, tests), on retombe sur une navigation classique.
 */
export const useNavigateTo = (): ((path: string) => void) => {
    const inRouter = useInRouterContext();
    // La présence du routeur ne change pas pendant la vie du composant :
    // l'ordre des hooks reste stable.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const navigate = inRouter ? useNavigate() : null;
    return useCallback((path: string) => {
        if (navigate) navigate(path);
        else window.location.assign(path);
    }, [navigate]);
};
